export default "__VITE_ASSET__D1YG__Pb__"